import { useEffect, useState } from "react";
import { useCart } from "../CartContext";
import { useNavigate } from "react-router-dom";

const API_BASE = "https://arttolczyk.pl";

export default function ProductModal({ product, lang, onClose }) {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAddedPopup, setShowAddedPopup] = useState(false);

  const images = Array.isArray(product.images) ? product.images : [];
  const videos = Array.isArray(product.videos) ? product.videos : [];

  const mediaItems = [...images, ...videos.map((v) => ({ video: v }))];

  // Scroll lock
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  const goNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((i) =>
      i < mediaItems.length - 1 ? i + 1 : 0
    );
  };

  const goPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((i) =>
      i > 0 ? i - 1 : mediaItems.length - 1
    );
  };

  const handleAddToCart = () => {
    addToCart(product);
    setShowAddedPopup(true);
  };

  const renderMedia = (item) => {
    if (item.video) {
      return (
        <video
          src={`${API_BASE}/videos/products/${item.video}`}
          controls
          autoPlay={false}
          style={{
            maxWidth: "100%",
            maxHeight: "80vh",
            borderRadius: "8px",
          }}
        />
      );
    }

    return (
      <img
        src={`${API_BASE}/images/products/${item}`}
        alt=""
        style={{
          maxWidth: "100%",
          maxHeight: "80vh",
          objectFit: "contain",
          borderRadius: "8px",
        }}
      />
    );
  };

  return (
    <div
      className="product-modal-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.85)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99999,
        padding: "20px",
      }}
    >
      <div
        className="product-modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "12px",
          maxWidth: "900px",
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "relative",
        }}
      >
        {/* X close */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            background: "transparent",
            color: "black",
            border: "none",
            fontSize: "30px",
            cursor: "pointer",
            zIndex: 200000,
          }}
        >
          ×
        </button>

        {/* Media */}
        <div
          style={{
            position: "relative",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          {mediaItems.length > 0 && renderMedia(mediaItems[currentIndex])}

          {/* Left arrow */}
          {mediaItems.length > 1 && (
            <button
              onClick={goPrev}
              style={{
                position: "absolute",
                left: -10,
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(255,255,255,0.7)",
                border: "none",
                padding: "8px 12px",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "20px",
              }}
            >
              ‹
            </button>
          )}

          {/* Right arrow */}
          {mediaItems.length > 1 && (
            <button
              onClick={goNext}
              style={{
                position: "absolute",
                right: -10,
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(255,255,255,0.7)",
                border: "none",
                padding: "8px 12px",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "20px",
              }}
            >
              ›
            </button>
          )}
        </div>

        {/* Miniatury galerii */}
        {mediaItems.length > 1 && (
          <div
            style={{
              display: "flex",
              gap: "8px",
              justifyContent: "center",
              marginBottom: "25px",
              flexWrap: "wrap",
            }}
          >
            {mediaItems.map((item, idx) => (
              <div
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                style={{
                  width: "64px",
                  height: "64px",
                  flexShrink: 0,
                  overflow: "hidden",
                  borderRadius: "6px",
                  border: idx === currentIndex
                    ? "2px solid black"
                    : "1px solid #ccc",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#fff",
                }}
              >
                {item.video ? (
                  <div style={{ fontSize: "24px", opacity: 0.7 }}>▶</div>
                ) : (
                  <img
                    src={`${API_BASE}/images/products/${item}`}
                    alt=""
                    style={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        )}

        {/* Product info */}
        <h2 style={{ marginBottom: "10px" }}>
          {lang === "pl" ? product.name_pl : product.name_en}
        </h2>

        <p style={{ whiteSpace: "pre-line", marginBottom: "20px" }}>
          {lang === "pl" ? product.desc_pl : product.desc_en}
        </p>

        <div
          style={{
            fontSize: "22px",
            fontWeight: "bold",
            marginBottom: "20px",
          }}
        >
          {lang === "en" && product.priceEUR
            ? `€${product.priceEUR} (${product.price} zł)`
            : `${product.price} zł`}
        </div>

        <button
          onClick={handleAddToCart}
          className="btn-primary"
          style={{
            padding: "12px 18px",
            fontSize: "18px",
            background: "black",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            marginBottom: "20px",
          }}
        >
          {lang === "pl" ? "Dodaj do koszyka" : "Add to cart"}
        </button>

        {/* POPUP after adding */}
        {showAddedPopup && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.3)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999999,
            }}
          >
            <div
              style={{
                background: "white",
                padding: "25px",
                borderRadius: "12px",
                textAlign: "center",
                width: "85%",
                maxWidth: "350px",
              }}
            >
              <h3 style={{ marginBottom: "20px" }}>
                {lang === "pl"
                  ? "Produkt dodany do koszyka"
                  : "Product added to cart"}
              </h3>

              <button
                onClick={() => {
                  setShowAddedPopup(false);
                  onClose();
                  navigate("/cart");
                }}
                style={{
                  padding: "12px",
                  background: "black",
                  color: "white",
                  border: "none",
                  width: "100%",
                  borderRadius: "8px",
                  fontSize: "16px",
                  marginBottom: "12px",
                }}
              >
                {lang === "pl" ? "Przejdź do koszyka" : "Go to cart"}
              </button>

              <button
                onClick={() => {
                  setShowAddedPopup(false);
                  onClose();
                }}
                style={{
                  padding: "12px",
                  background: "#eee",
                  border: "1px solid #ccc",
                  width: "100%",
                  borderRadius: "8px",
                  fontSize: "16px",
                }}
              >
                {lang === "pl" ? "Kontynuuj zakupy" : "Continue shopping"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
